import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="235240" id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/florida_storm_protection.png)]" />

      {}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary/95 via-secondary/70 to-primary/20" />

      {}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto w-full pt-20 pb-16">
        
        {}
        <p className="text-primary font-sans text-sm sm:text-base md:text-lg uppercase tracking-widest font-bold mb-6 animate-in fade-in slide-in-from-bottom-4 duration-1000">
          Wind Mitigation Inspection for South Florida Homeowners
        </p>

        {}
        <div className="backdrop-blur-sm bg-background/10 border border-white/10 rounded-2xl p-6 md:p-10 mb-8 shadow-2xl animate-in fade-in zoom-in-95 duration-1000 delay-150">
          <h1 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight">
            Wind Mitigation
            <br className="hidden sm:block" /> Inspection Services
          </h1>
        </div>

        {}
        <p className="text-white/90 font-sans text-lg sm:text-xl md:text-2xl max-w-2xl mb-12 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
          Professional storm readiness assessments for South Florida homeowners and insurance savings.
        </p>

        {}
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground border-0 rounded-full shadow-xl shadow-primary/20 hover:shadow-primary/40 transition-all duration-300 hover:translate-y-0.5 text-lg px-10 py-7 h-auto font-bold">
            <Link to="/WindMitigationInspectionPage">Schedule Inspection</Link>
          </Button>
        </div>
      </div>
    </section>;
}